import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
const PhoneIcon = ({ className, size }) => {
    if (size === 'small') {
        return (React.createElement("svg", { className: getClassName(className), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor" },
            React.createElement("path", { fillRule: "evenodd", d: "M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })));
    }
    return (React.createElement("svg", { className: getClassName(className), xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" })));
};
PhoneIcon.propTypes = {
    size: PropTypes.oneOf(['small', 'medium']),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
PhoneIcon.defaultProps = {
    size: 'small',
    className: 'w-6 h-6',
};
export default PhoneIcon;
